import type { HabilitationDTO } from '@/features/api/habilitation/dto/habilitation'
import type { TypePermission, NiveauPermission } from '@/features/domaine/types/opco'
import { storeToRefs } from 'pinia'
import { useHabilitationsAdminContentStore } from './useHabilitationsAdminContentStore'

export function useHabilitationsPermissions(store = useHabilitationsAdminContentStore()) {
  const { isReadonly, dataToken } = storeToRefs(store)

  const getPermission = (habilitation: HabilitationDTO, typePermission: TypePermission) =>
    habilitation.autorisations.permissions.find((p) => p.type === typePermission)?.niveau

  const setPermission = async (habilitation: HabilitationDTO, typePermission: TypePermission, n: NiveauPermission) => {
    if (isReadonly.value) return
    await store.updateNiveauPermission({ habilitation, type: typePermission, niveau: n })
  }

  const togglePermission = (habilitation: HabilitationDTO, typePermission: TypePermission) => {
    if (!canToggle(habilitation, typePermission)) return
    const cur = getPermission(habilitation, typePermission)
    const next: NiveauPermission = cur === 'Ecriture' ? 'Aucun' : 'Ecriture'
    return setPermission(habilitation, typePermission, next)
  }

  const isDeactivated = (habilitation: HabilitationDTO, typePermission: TypePermission) =>
    getPermission(habilitation, typePermission) !== 'Ecriture'

  const isAdminLocal = (habilitation: HabilitationDTO) => dataToken.value?.userId === habilitation.userId

  const canToggle = (habilitation: HabilitationDTO, typePermission: TypePermission) =>
    !isReadonly.value && !(typePermission === 'Administration' && isAdminLocal(habilitation))

  return {
    // lecture/écriture
    getPermission,
    setPermission,
    togglePermission,
    // états UI
    isDeactivated,
    canToggle,
    isAdminLocal,
    isReadonly,
  }
}
